module.exports = __webpack_public_path__ + "img/bigTruck-grey.119cb0ab.svg";